import React from 'react';
import { ArcCollapse, ArcStack, ArcStatusPoint, ArcText } from '@src/core/ui';
import { ReactComponent as ArrowUpIcon } from '@src/assets/icons/arrow-up.svg';
import { useDispatch, useSelector } from 'react-redux';
import { DroneStatusColors, DroneStatusNames, ToggleCollapseViewProps } from './types';
import { selectCollapse } from '@src/features/drone/redux/selectors';
import { toggleCollapse } from '@src/features/drone/redux';

const ToggleCollapseView: React.FC<ToggleCollapseViewProps> = (props) => {
  const { status, children, count = 0 } = props;

  const dispatch = useDispatch();
  const collapse = useSelector(selectCollapse);

  const isDisabled = count < 1;
  const isOpen = collapse[status];
  
  const onToggleCollapse = () => {
    dispatch(toggleCollapse(status));
  };

  const onClick = () => {
    if (isDisabled) {
      return;
    }
    onToggleCollapse();
  };

  const renderIcon = () => {
    if (isDisabled) {
      return null;
    }

    return (
      <ArrowUpIcon width={18} style={{
        transform: `rotate(${isOpen ? '0deg' : '180deg'})`,
        transition: 'transform 0.3s',
      }}  />
    );
  };

  return (
    <ArcStack>
      <ArcStack 
        spacing={1} 
        direction='row' 
        alignItems='center'
        justifyContent='space-between'
        sx={{ cursor: 'pointer' }}
        onClick={onClick}>

        <ArcStack 
          spacing={1} 
          direction='row' 
          alignItems='center'>
          <ArcStatusPoint.s bgcolor={DroneStatusColors[status]} />
          <ArcText.h5 
            color={isDisabled ? 'text.secondary' : 'text.primary'}> 
            {DroneStatusNames[status]} ({count})
          </ArcText.h5>
        </ArcStack>

        {renderIcon()}
      </ArcStack>

      <ArcCollapse in={isOpen} timeout="auto" unmountOnExit={false}>
        {children}
      </ArcCollapse>
    </ArcStack>
  );
};

export default ToggleCollapseView;
